import { render, staticRenderFns } from "./AgreementItemCreateEditModal.vue?vue&type=template&id=490fb1f8"
import script from "./AgreementItemCreateEditModal.vue?vue&type=script&lang=js"
export * from "./AgreementItemCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports